<!-- <div class="preloader">
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20"
    fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
  </svg>
</div> -->

<!-- <div *ngIf="showLoadingIndicator" class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div> -->

<!-- <div class="lds-roller">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div> -->


<!-- <mat-spinner></mat-spinner> -->


<div class="loading-indicator">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>



